import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { EventStationResponseItem } from '../types';
import { CreateStationDialog } from './create-station-dialog';

interface StationFormProps {
  selectedStationId: string;
  setSelectedStationId: (id: string) => void;
  eventId: string;
  stations: EventStationResponseItem[];
}

export const Stations = ({
  selectedStationId,
  setSelectedStationId,
  stations,
  eventId,
}: StationFormProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4  mb-4">
      <h2 className="font-bold text-2xl">Stations</h2>
      {stations.length === 0 ? (
        <div className="flex items-center justify-center flex-col gap-5 py-10">
          <p className="text-zinc-50 font-semibold text-lg">
            Create Stations before uploading the Inventory CSV file.
          </p>
          <p className="text-zinc-400">
            Use the "Create Stations" button below to get started.
          </p>

          <Button
            onClick={() => setIsDialogOpen(true)}
            data-testid="create-participant-types-button"
          >
            Create Stations
          </Button>
        </div>
      ) : (
        <div className="flex gap-10 justify-between align-center">
          <div className="w-full">
            <Select
              value={selectedStationId}
              onValueChange={(val) => setSelectedStationId(val)}
            >
              <Label htmlFor="station">Station</Label>
              <SelectTrigger id="station" className="w-full mt-1">
                <SelectValue placeholder="Station Name" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {stations.map((station) => (
                    <SelectItem value={station.id} key={station.id}>
                      {station.name}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <div className="w-full flex gap-5 items-center justify-end">
            <div className="text-zinc-400 text-sm text-right">
              <p>Manage existing stations.</p>
              <p>Use the "Stations" button to view or update them.</p>
            </div>
            <Button variant="outline" onClick={() => setIsDialogOpen(true)}>
              Stations
            </Button>
          </div>
        </div>
      )}
      {/* MODALS */}
      <CreateStationDialog
        isOpen={isDialogOpen}
        eventId={eventId}
        stations={stations}
        onOpenChange={setIsDialogOpen}
      />
    </div>
  );
};
